<template>
  <div class="ToastMain" :class="[{ToastRightOne:!Toast.state},{ToastRightTwo:Toast.state}]">
    <span class="icon iconfont iconicon-test65 ToastIcon greenColor" v-if="Toast.type == 0"></span>
    <span class="icon iconfont iconicon-test44 ToastIcon orangeColor" v-else-if="Toast.type == 1"></span>
    <span class="icon iconfont iconicon-test33 ToastIcon redColor" v-else></span>
    <div class="ToastTxt" v-text="Toast.txt"></div>
  </div>
</template>

<script>
var self;
export default {
  name: 'Toast',
  props: ['Toast'],
  data () {
    return {
      m:3000
    }
  },
  created () {
    self = this;
  },
  updated () {
    if(self.Toast.state){
      setTimeout(function(){
        self.$emit('ChangeToast');
      },self.m)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Toast.vue